import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  Modal,
  Button
} from '@lockerpm/design';

import dayjs from 'dayjs'

const GetCodeConfirmModal = (props) => {
  const { t } = useTranslation();
  const {
    visible = false,
    availablePercent = 0,
    remainPercent = 0,
    callingAPI = false,
    onClose = () => {},
    getCode = () => {}
  } = props;

  const currentTime = useMemo(() => {
    return dayjs().add(7, 'days').format('MMMM Do YYYY')
  }, [visible])

  return (
    <Modal
      title={
        <div className="text-xl text-black-700 font-semibold truncate">
          {t('rewards.get_code.popup.title', { percent: availablePercent }) }
        </div>
      }
      open={visible}
      width={470}
      onCancel={() => onClose()}
      footer={false}
    >
      <div className="text-center">
        <div className="mb-5">
          {t('rewards.get_code.popup.desc', { percent: remainPercent }) }:
        </div>
        <Button
          type="primary"
          loading={callingAPI}
          onClick={() => getCode()}
        >
          {t('rewards.get_code.title')}
        </Button>
        <div className="text-xs mt-5">
          {t('rewards.get_code.popup.note', { time: currentTime })}:
        </div>
      </div>
    </Modal>
  );
}

export default GetCodeConfirmModal;